/**
 * returns a millisecond value of the required future time
 * @param minutes
 * @returns {number}
 */
let futureDate = (minutes) => {
  let date = new Date()
  let currentTime = date.getTime()
  let addTime = 60000 * minutes
  let finalTime = currentTime + addTime
  return finalTime
}

/**
 * compares two times
 * @param timeOne
 * @param timeTwo
 * @returns {boolean}
 */
let compareTime = (timeOne, timeTwo) => {
  if (timeOne === null || timeTwo === null) {
    return false
  }
  return timeOne < timeTwo
}

export default {
  futureDate,
  compareTime
}
